import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { rules, Form, Input } from 'react-validation/lib/build/validation.rc';
import { initRules } from 'utils/ValidateUtils';
import { requestPasswordReset } from 'utils/MemberUtils';
import Spinner from 'components/shared/spinner';
import MemberFormDefaultMessage from 'constants/MemberFormDefaultMessage';

class ForgetPassword extends Component {
  static propTypes = {
    btnText: PropTypes.string,
    successMsg: PropTypes.string,
    mainErrorMsg: PropTypes.string
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    btnText: MemberFormDefaultMessage.REQUEST_PASSWORD_RESET_BUTTON,
    successMsg: MemberFormDefaultMessage.REQUEST_PASSWORD_RESET_SUCCESS,
    mainErrorMsg: MemberFormDefaultMessage.ERROR_MSG
  }

  state = {
    submitted: false,
    errorMsgs: [],
    isLoading: false,
  }

  componentWillMount() {
    _.assign(rules, initRules((message) => <span className="Form-control-errorMessage">{message}</span>));
  }

  _onSubmitForm(event) {
    event.preventDefault();

    if (this._isFormValid()) {
      this.setState({
        isLoading: true
      });

      const {
        components: {
          email: {
            state: {
              value: email = ''
            } = {}
          } = {}
        } = {}
      } = this.form;

      requestPasswordReset(email).then(() => {
        this.setState({
          submitted: true,
          isLoading: false
        });
      }).catch((error) => {
        this.setState({
          errorMsgs: error.data || [error.statusText],
          isLoading: false
        });
      });
    }
  }

  _isFormValid() {
    return _.isEmpty(this.form.validateAll());
  }

  render() {
    const {
      btnText,
      successMsg,
      mainErrorMsg
    } = this.props;

    const {
      submitted,
      errorMsgs,
      isLoading
    } = this.state;

    if (isLoading) {
      return (
        <div className="FormLoading">
          <Spinner active />
        </div>
      );
    }

    if (submitted) {
      return (
        <div className="Notification Notification--success">
            <div className="Notification-message" dangerouslySetInnerHTML={{__html: successMsg}} />
        </div>
      );
    }

    return (
      <Form className="Form Form-center" ref={form => this.form = form} onSubmit={(event) => this._onSubmitForm(event)}>
        { errorMsgs.length > 0 &&
          <div className="Form-center--header">
            <div className="Notification Notification--error">
              <div className="Notification-message" dangerouslySetInnerHTML={{__html: mainErrorMsg}} />
              {
                errorMsgs.map((msg, index) => <div key={index} className="Notification-message">{msg}</div>)
              }
            </div>
          </div>
        }
        <div className="Form-center--body">
          <div className="Form-control">
            <Input className="Form-control-input"
              validations={['required', 'email']}
              value=""
              name="email"
              errorClassName="Form-control-input--error"
              placeholder="enter your email *"
            />
          </div>
        </div>
        <div className="Form--footer Form-center--footer">
          <button className="Form-submitBtn">{btnText}</button>
        </div>
      </Form>
    );
  }
}

export default ForgetPassword;



// WEBPACK FOOTER //
// ./app/components/membership/ForgetPassword.js